// store/admin/question-bank/store/saga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './_actionTypes';
import * as actions from './_actions';
import QuestionBankHelper from '@/utils/API/BackendHelper/admin/questionBank';

// Create single question
function* createQuestionSaga(action) {
  try {
    const response = yield call([QuestionBankHelper, 'createQuestion'], action.payload);
    
    if (response.success) {
      yield put(actions.createQuestionSuccess(response.data));
    } else {
      yield put(actions.createQuestionFailure(response.message || 'Failed to create question'));
    }
  } catch (error) {
    yield put(actions.createQuestionFailure(error.message));
  }
}

// Bulk create questions
function* bulkCreateQuestionsSaga(action) {
  try {
    const response = yield call([QuestionBankHelper, 'bulkCreateQuestions'], action.payload);
    
    if (response.success) {
      yield put(actions.bulkCreateQuestionsSuccess(response.data));
    } else {
      yield put(actions.bulkCreateQuestionsFailure(response.message || 'Failed to create questions'));
    }
  } catch (error) {
    yield put(actions.bulkCreateQuestionsFailure(error.message));
  }
}

// Get questions by course
function* getQuestionsByCourseSaga(action) {
  try {
    const { courseId } = action.payload;
    const response = yield call([QuestionBankHelper, 'getQuestionsByCourse'], courseId);
    
    if (response.success) {
      yield put(actions.getQuestionsByCourseSuccess(response.data));
    } else {
      yield put(actions.getQuestionsByCourseFailure(response.message || 'Failed to fetch questions'));
    }
  } catch (error) {
    yield put(actions.getQuestionsByCourseFailure(error.message));
  }
}

// Update question
function* updateQuestionSaga(action) {
  try {
    const { questionId, updateData } = action.payload;
    const response = yield call([QuestionBankHelper, 'updateQuestion'], questionId, updateData);
    
    if (response.success) {
      yield put(actions.updateQuestionSuccess(response.data));
    } else {
      yield put(actions.updateQuestionFailure(response.message || 'Failed to update question'));
    }
  } catch (error) {
    yield put(actions.updateQuestionFailure(error.message));
  }
}

// Delete question
function* deleteQuestionSaga(action) {
  try {
    const { questionId } = action.payload;
    const response = yield call([QuestionBankHelper, 'deleteQuestion'], questionId);
    
    if (response.success) {
      yield put(actions.deleteQuestionSuccess(questionId));
    } else {
      yield put(actions.deleteQuestionFailure(response.message || 'Failed to delete question'));
    }
  } catch (error) {
    yield put(actions.deleteQuestionFailure(error.message));
  }
}

// Bulk delete questions
function* bulkDeleteQuestionsSaga(action) {
  try {
    const { ids } = action.payload;
    const response = yield call([QuestionBankHelper, 'bulkDeleteQuestions'], ids);

    if (response.success) {
      yield put(actions.bulkDeleteQuestionsSuccess(ids));
    } else {
      yield put(actions.bulkDeleteQuestionsFailure(response.message || 'Failed to delete questions'));
    }
  } catch (error) {
    yield put(actions.bulkDeleteQuestionsFailure(error.message));
  }
}

// Watcher saga
export default function* questionBankSaga() {
  yield takeLatest(types.CREATE_QUESTION_REQUEST, createQuestionSaga);
  yield takeLatest(types.BULK_CREATE_QUESTIONS_REQUEST, bulkCreateQuestionsSaga);
  yield takeLatest(types.GET_QUESTIONS_BY_COURSE_REQUEST, getQuestionsByCourseSaga);
  yield takeLatest(types.UPDATE_QUESTION_REQUEST, updateQuestionSaga);
  yield takeLatest(types.DELETE_QUESTION_REQUEST, deleteQuestionSaga);
  yield takeLatest(types.BULK_DELETE_QUESTIONS_REQUEST, bulkDeleteQuestionsSaga);
}
